import React from "react";
import { LegalLayout } from "@/components/LegalLayout";
import { PRIVACY_NOTICE, TERMS_OF_BUSINESS, GUIDE_TO_SERVICE } from "./legalContent";

export function PrivacyNotice() { return <LegalLayout doc={PRIVACY_NOTICE} />; }
export function TermsOfBusiness() { return <LegalLayout doc={TERMS_OF_BUSINESS} />; }
export function GuideToService() { return <LegalLayout doc={GUIDE_TO_SERVICE} />; }
